import { action, observable } from 'mobx';
import * as complaintInternalActions from '../../OnlineReception/actions/complaintInternal';
import { ComplaintStatistic } from '../../OnlineReception/models/complaintStatistic';

class ComplaintMetricStore {
    @observable complaintStatistics: ComplaintStatistic[];

    constructor() {
        this.complaintStatistics = [];
    }

    @action('load complaint statistics')
    loadComplaintStatistic = (): Promise<any> => {
        return complaintInternalActions.complaintStatistic()
            .then((res: ComplaintStatistic[]) => this.setComplaintStatistics(res));
    };

    @action.bound
    setComplaintStatistics(complaintStatistics: ComplaintStatistic[]) {
        this.complaintStatistics = complaintStatistics;
    }

    /**
     * Получить статистику по конретному статусу
     * @param value
     */
    getStatisticByStatus(value: string): number {
        let index: number = this.complaintStatistics.findIndex((el: ComplaintStatistic) => el.publicStatus.value === value);
        return index === -1 ? 0 : this.complaintStatistics[index].count;
    }
}

const complaintMetricStore = new ComplaintMetricStore();

export default complaintMetricStore;
export { ComplaintMetricStore };
